/** At most `max` evenly spaced labels from a series' x values, so a long axis does not print over itself. */
export function thinTicks(labels: readonly string[], max = 6): string[] {
  const stride = Math.max(1, Math.ceil(labels.length / max));
  return labels.filter((_, index) => index % stride === 0);
}

/** Count axes: label and grid whole numbers only, so a max of 4 doesn't read 0.5, 1.5 ... */
export function wholeNumberTicks(max: number, limit = 10): number[] | undefined {
  return max <= limit ? Array.from({ length: Math.ceil(max) + 1 }, (_, i) => i) : undefined;
}
